/*
*
* File JS per la Single Video
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';

// COMPONENTI CUSTOM BLOCKS - VIDEO
import blockText from 'components/block-text/block-text';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';


//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-video.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockVideo();

//--------------------------------------------------------------------//